import { Modal } from 'components/Modal/Modal';
import i18n from 'i18n';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './creativeErrorsModal.module.scss';

export const CreativeErrorsModal: React.FC<{
  errors: {
    name: string;
    error_message: string | null;
  }[];
}> = ({ errors }) => {
  const history = useHistory();
  const location = useLocation();

  const errorContent = errors.map((error, index) => (
    <li key={index}>
      <div className={styles.errorInfo}>
        <div>{'Name:'}</div>
        <div>{error.name}</div>
        <div>{'Error:'}</div>
        <div>
          {error.error_message === null
            ? i18n.t<string>('serverResponse.500000')
            : error.error_message}
        </div>
      </div>
    </li>
  ));
  const hideModal = () => {
    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: undefined
    });
  };
  return (
    <Modal
      className={styles.createCreativeErrorModal}
      title={i18n.t<string>('creativesHome.titles.createCreativeErrorModal')}
      primaryButton={{
        title: i18n.t<string>('common.buttons.ok'),
        callback: hideModal
      }}
      dismiss={hideModal}
    >
      <ul className={styles.createCreativeErrorList}>{errorContent}</ul>
    </Modal>
  );
};
